export const SAVE_BUTTON_CLIKED = 'GenerateAgreementForm/SAVE_BUTTON_CLIKED';
export const SUBMIT_AGREEMENT_FORM = 'GenerateAgreementForm/SUBMIT_AGREEMENT_FORM';
